"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCheckOrder = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const useInject_1 = require("./useInject");
/**
 * 提供一个用于下单或者报价的异步接口，改hook会对它进行封装，增强以下能力
 * 1、参数检查
 * 2、静态参数补充
 */
function useCheckOrder({ orderItem_ }, props, injectModule) {
    const { checkOrder, useExternalParameter = false } = props !== null && props !== void 0 ? props : {};
    const enhancedCheckOrder = (0, react_1.useMemo)(() => checkOrder
        ? () => __awaiter(this, void 0, void 0, function* () {
            const { SpuItem, ExternalParameterList } = yield (0, rxjs_1.firstValueFrom)(orderItem_);
            const req = useExternalParameter ? { SpuItem, ExternalParameterList } : { SpuItem };
            return (0, useInject_1.injectAsyncRunner)(checkOrder, [req], injectModule);
        })
        : checkOrder, [checkOrder, orderItem_, useExternalParameter, injectModule]);
    return { checkOrder: enhancedCheckOrder };
}
exports.useCheckOrder = useCheckOrder;
